import * as React from 'react';


const LogoFrukt: React.FC = () => {
    return (
        <div className="w-14 laptop:w-20 shrink-0">
            <a
                title="Til forsiden"
                className="shrink-0 outline-offset-8"
                href="/"
            >
                <img
                    src="/frukt/img/logo_circle_small.png"
                    className="logo w-14 h-14 laptop:w-20 laptop:h-20"
                    srcSet="/frukt/img/logo_circle_small.png 1x, /frukt/img/logo_circle_large.png 2x"
                    alt="Opplysningskontoret for frukt og grønt"
                />
            </a>
        </div>
    );
};

export default LogoFrukt;
